import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeAirlineListItem extends SearchModelBase {
    name: string = '';
    country: string = '';
    prefix: string = '';
    abbr: string = '';
    abbr3: string = '';
    nextblNo: string = '';
    endblNo: string = '';
    accountNo: string = '';
    aefscRate: number|null = null;
    fromAefscRate: number|null = null;
    toAefscRate: number|null = null;
    aesscRate: number|null = null;
    fromAesscRate: number|null = null;
    toAesscRate: number|null = null;
    aefscMin: number|null = null;
    fromAefscMin: number|null = null;
    toAefscMin: number|null = null;
    aesscMin: number|null = null;
    fromAesscMin: number|null = null;
    toAesscMin: number|null = null;
    id: number = 0;
    countryUnCode: string = '';
    freightVendorName: string = '';
    updateDate: string | null = null;
    toUpdateDate: string | null = null;
    fromUpdateDate: string | null = null;
    updateBy: string = '';


    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Airline Name', width: 350, dataIndex: 'name'}),
        XCol.Create({ col: 1, text: 'Country', width: 200, dataIndex: 'country'}),
        XCol.Create({ col: 2, text: 'Prefix', width: 80, dataIndex: 'prefix'}),
        XCol.Create({ col: 3, text: 'Abbr 2', width: 70, dataIndex: 'abbr'}),
        XCol.Create({ col: 4, text: 'Abbr 3', width: 70, dataIndex: 'abbr3'}),
        XCol.Create({ col: 5, text: 'Next AWB #', width: 110, dataIndex: 'nextblNo'}),
        XCol.Create({ col: 6, text: 'End AWB #', width: 110, dataIndex: 'endblNo'}),
        XCol.Create({ col: 7, text: 'Freight Vendor', width: 110, dataIndex: 'freightVendorName'}),
        XCol.Create({ col: 8, text: 'FSC Rate', width: 150, dataIndex: 'aefscRate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 9, text: 'FSC Min', width: 110, dataIndex: 'aefscMin', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'SSC Rate', width: 150, dataIndex: 'aesscRate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'SSC Min', width: 110, dataIndex: 'aesscMin', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Update Date', width: 110, dataIndex: 'updateDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center})
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeAirlineListItem.prototype.name , orderByAscending: true };

    public static formatData(data: CodeAirlineListItem[]) {
        return data.map((d: CodeAirlineListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        aefscRate: {from: 'fromAefscRate', to: 'toAefscRate'},
        aefscMin: {from: 'fromAefscMin', to: 'toAefscMin'},
        aesscRate: {from: 'fromAesscRate', to: 'toAesscRate'},
        aesscMin: {from: 'fromAesscMin', to: 'toAesscMin'},
        updateDate: {from: 'fromUpdateDate', to: 'toUpdateDate'},
    }
}
